import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import DigimagiProvider from './components/DigimagiProvider';
import store from './redux/store';

ReactDOM.render(
  <Provider store={store}><DigimagiProvider /></Provider>,
document.getElementById('root'))
